import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import TherapistContext from './TherapistContext';
import useFetchQuery from '../../../../hooks/useFetchQuery';
import useGetCurrentLocation from '../../../../hooks/useGetCurrentLocation';

function TherapistContextProvider({ children }) {
    const { masseusesId } = useParams();
    const { lat, lng } = useGetCurrentLocation();

    const { data, isLoading } = useFetchQuery({
        url: `/masseuses/${masseusesId}`,
        method: 'get',
        params: {
            lat,
            lng,
        },
        onFetchSuccess: (data) => {
            return data?.data;
        },
    });

    const { data: dataReviews, isLoading: loadingReviews } = useFetchQuery({
        url: `/masseuses/${masseusesId}/reviews`,
        method: 'get',
        params: {
            cursor: 0,
            limit: 50,
        },
        onFetchSuccess: (data) => {
            return {
                reviews: data?.data?.reviews || [],
                reviewsCount: data?.data?.review_count || 0,
            };
        },
    });

    const { data: listServiceMasseuse, isLoading: isLoadingListService } = useFetchQuery({
        enabled: () => masseusesId,
        url: `/masseuses/${masseusesId}/services`,
        method: 'get',
        onFetchSuccess: (data) => {
            return data?.data?.services || [];
        },
    });

    const contextValue = useMemo(() => {
        return {
            therapist: data,
            isLoading,
            services: listServiceMasseuse,
            isLoadingListService,
            dataReviews: dataReviews?.reviews,
            loadingReviews,
            reviewsCount: dataReviews?.reviewsCount,
        };
    }, [data, isLoading, listServiceMasseuse, isLoadingListService, dataReviews, loadingReviews]);

    return <TherapistContext.Provider value={contextValue}>{children}</TherapistContext.Provider>;
}

export default TherapistContextProvider;
